export function getProjectPhaseColor(projectPhase: string | null | undefined) {
  switch (projectPhase) {
    case "planning":
      return "bg-crimson"
    case "offering":
      return "bg-blue"
    case "execution":
      return "bg-green"
    case "closed":
    default:
      return "bg-gray"
  }
}
